module.exports = __webpack_public_path__ + "static/media/bus.d06144bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bus.svg
// module id = 329
// module chunks = 0